// Schreiben-Assistent (#586): Einstieg von einer Einheit – laufende Mieter als Empfänger, sonst der Eigentümer
// der Einheit; das Objekt wird für „alle eines Objekts“ vorgewählt.

export function schreibenPfad({ objektId, mieterIds, eigentuemerId }: { objektId: string; mieterIds: string[]; eigentuemerId: string | null }): string {
  const p = new URLSearchParams();
  const mieter = [...new Set(mieterIds.filter(Boolean))];
  if (mieter.length) for (const id of mieter) p.append('empfaenger', `mieter:${id}`);
  else if (eigentuemerId) p.append('empfaenger', `eigentuemer:${eigentuemerId}`);
  p.set('objekt', objektId);
  return `/admin/schreiben/neu?${p.toString()}`;
}
